import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    this.load();
  }

  load() {
    let url = this.data.get('url');

    if (this.data.get('query')) {
      url = `${url}?${this.data.get('query')}`;
    }

    fetch(url, { credentials: 'same-origin' })
      .then(response => response.text())
      .then(html => {
        this.element.outerHTML = html
      });
  }
}
